// src/context/AuthContext.jsx
import { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userName, setUserName] = useState("Admin");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loggedIn = localStorage.getItem("isLoggedIn") === "true";
    const savedName = localStorage.getItem("userName");

    if (loggedIn) {
      setIsLoggedIn(true);
      if (savedName) setUserName(savedName);
    }
    setLoading(false);
  }, []);

  const login = (name = "Admin") => {
    localStorage.setItem("isLoggedIn", "true");
    localStorage.setItem("userName", name);
    setIsLoggedIn(true);
    setUserName(name);
  };

  const logout = () => {
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("userName");
    setIsLoggedIn(false);
    setUserName("Admin");
  };

  return (
    <AuthContext.Provider value={{ isLoggedIn, userName, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};